import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/contact-log';


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryContactLogWidgetSuccess as MemberDetailsCommunicationHistoryContactLogWidgetSuccess } from 'ui/views/widgets/memberDetailsCommunicationHistoryContactLogWidget';
 *
 * // render
 * <MemberDetailsClaimsEntityWidgetSuccess propName='propValue'/>
 */
const memberDetailsCommunicationHistoryContactLogWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-communication-history-contact-log-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                sortFilterMode = 'offline'
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryContactLogWidgetSuccess.displayName = 'memberDetailsCommunicationHisStoryWidget';

// set default props
memberDetailsCommunicationHistoryContactLogWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsCommunicationHistoryContactLogWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsCommunicationHistoryContactLogWidgetPreloader as MemberDetailsCommunicationHistoryContactLogWidgetPreloader } from 'ui/views/widgets/memberDetailsCommunicationHistoryContactLogWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryContactLogWidgetPreloader propName='propValue'/>
 */
const memberDetailsCommunicationHistoryContactLogWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-communication-history-contact-log-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-communication-history-contact-log-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryContactLogWidgetPreloader.displayName = 'memberDetailsCommunicationHistoryContactLogWidgetPreloader';

// set default props
memberDetailsCommunicationHistoryContactLogWidgetPreloader.defaultProps = {};

// prop types
memberDetailsCommunicationHistoryContactLogWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryContactLogWidget as MemberDetailsCommunicationHistoryContactLogWidget } from 'ui/views/widgets/memberDetailsCommunicationHistoryContactLogWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryContactLogWidget propName='propValue'/>
 */
export const memberDetailsCommunicationHistoryContactLogWidget = withNetworkState( memberDetailsCommunicationHistoryContactLogWidgetPreloader, memberDetailsCommunicationHistoryContactLogWidgetSuccess );

